/* eslint-disable */
import Swiper, { Navigation, Pagination } from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([Navigation, Pagination]);

(function() {
function loadSwipers() {
  // eslint-disable-next-line no-unused-vars
  new Swiper('.indexers-swiper', {
    slidesPerView: 2,
    spaceBetween: 14,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    navigation: {
      nextEl: '.swiper-button-next-indexers',
      prevEl: '.swiper-button-prev-indexers',
    },
    breakpoints: {
      470: {
        slidesPerView: 3,
      },
      770: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 70,
      },
    },
    on: {
      init: function () {
        updateWrapperClass(this);
      },
      resize: function () {
        updateWrapperClass(this);
      },
    },
  });

  function updateWrapperClass(swiperInstance) {
    const wrapper = swiperInstance.wrapperEl;
    const slideCount = swiperInstance.slides.length;
    const cinco = 5;

    if (slideCount <= cinco) {
      wrapper.classList.add('indexers-list-centered'); // Adicione o nome da classe desejada aqui
    } else {
      wrapper.classList.remove('indexers-list-centered'); // Remova a classe se houver mais de 5 slides
    }
  }


  // eslint-disable-next-line no-unused-vars
  new Swiper('.banner-home__swiper', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    responsive: true,
    observer: true,
    spaceBetween: 32,
    navigation: {
      nextEl: '.swiper-button-next-banners',
      prevEl: '.swiper-button-prev-banners',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
  });

  // eslint-disable-next-line no-unused-vars
  new Swiper('.supporters-swiper', {
    slidesPerView: 4,
    slidesPerGroup: 4,
    responsive: true,
    observer: true,
    centerInsufficientSlides: true,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next-supporters',
      prevEl: '.swiper-button-prev-supporters',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
    breakpoints: {
      768: {
        spaceBetween: 35,
      },
    },
  });

  // eslint-disable-next-line no-unused-vars
  new Swiper('.editor-message__swiper', {
    slidesPerView: 1,
    slidesPerGroup: 1,
    responsive: true,
    observer: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next-editor-message',
      prevEl: '.swiper-button-prev-editor-message',
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: 'bullets',
    },
  });

  // eslint-disable-next-line no-unused-vars
  const covers = document.querySelectorAll('.covers-swiper');
  covers.forEach((cover) => {
  // eslint-disable-next-line no-unused-vars
    new Swiper(cover, {
      slidesPerView: 3,
      slidesPerGroup: 3,
      responsive: true,
      observer: true,
      // centerInsufficientSlides: true,
      watchOverflow: true,
      spaceBetween: 16,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        type: 'bullets',
      },
      breakpoints: {
        768: {
          spaceBetween: 10,
        },
      },
    });
  });

  // eslint-disable-next-line no-unused-vars
  new Swiper('.Numeros', {
    slidesPerView: 3,
    slidesPerGroup: 3,
    responsive: true,
    // observer: true,
    centerInsufficientSlides: true,
    spaceBetween: 16,
    // pagination: {
    //   el: '.swiper-pagination',
    //   clickable: true,
    //   type: 'bullets',
    // },
    breakpoints: {
      768: {
        spaceBetween: 10,
      },
    },
  });

}

window.addEventListener('load', loadSwipers);

})();
